var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.585 3.04c.37-.272.37-.588 0-.86L5.361.552c-.483-.369-.984-.22-.984.431v1.16H4.2C1.68 2.144 0 3.84 0 6.354v1.318a.55.55 0 0 0 1.099 0v-1.31c0-1.88 1.204-3.198 3.111-3.198h.167v1.072c0 .633.5.782.984.422zm7.77 16.709c1.502 0 2.25-.721 2.25-2.26V8.798c0-1.538-.748-2.258-2.25-2.258h-8.72c-1.502 0-2.25.72-2.25 2.258v8.693c0 1.538.748 2.259 2.25 2.259zm-.027-1.415H6.662c-.598 0-.861-.247-.861-.87v-8.64c0-.624.263-.87.861-.87h8.666c.598 0 .861.246.861.87v8.64c0 .624-.263.87-.86.87"
  })));
};
export default SvgRotate;